module.exports = __webpack_public_path__ + "img/moneyrain.b8667ce1.svg";